<template>
    
    <div>
      <div v-if="!hasModule('IncomingDocManagement')" class="alert alert-danger">
        {{translate('warnings.incomingDocManagementText')}}
      </div>
      <list-container :header="editFilters ? translate('incomingDocumentList.incomingDocFilters') : translate('navigation.incomingDoc')">
          <template v-slot:commands>
             <button
                class="btn btn-info"
                @click="resetComponent"
                v-show="editFilters"
              >
              {{translate('incomingDocumentList.clearFilter')}}
              </button>
              <excel-exporter
                v-show="!editFilters"
                table-id="incomingDocExport"
                :columns="columns"
                url="/incomingDoc/get"
                modelName="IncomingDoc"
                :hideDeleteCommand="true"
                :filter="filterForm"
              ></excel-exporter>
              <button
                accesskey="t"
                class="btn btn-primary"
                @click="editFilters = true"
                v-show="!editFilters"
                v-html="translate('incomingDocumentList.editFilters')"
              >
                
              </button>
          </template>
  
        <div class="rbcontent">
            <incoming-doc-filter
              v-if="editFilters"
              :filter="filterForm"
              @apply="applyFilter"
              @cancel="editFilters = false"
              :target-systems="targetSystems"
              :departments="availableDepartments"
              :categories="categories"
              :filters="incomingFilters"
              :incomingChannel="incomingChannels"
              :users="users"
              
            ></incoming-doc-filter>
            
            <div class="row" v-show="!editFilters">
                <div class="col-12">
                    <!-- <code>{{filterForm}}</code> -->
                    <table class="table table-borderless table-sm ozet">
                    <tbody>
                        <tr v-show="filterForm.documentId">
                        <td>{{translate('incomingDocFilter.documentNo')}}</td>
                        <td>:</td>
                        <td>
                            {{ filterForm.documentId }}
                        </td>
                        </tr>
                        <tr v-show="filterForm.sender">
                        <td>{{translate('targetSystem.rem.sender')}}</td>
                        <td>:</td>
                        <td>
                            {{ filterForm.sender }}
                        </td>
                        </tr>
                        <tr v-show="filterForm.name">
                        <td>{{translate('targetSystem.rem.subject')}}</td>
                        <td>:</td>
                        <td>
                            {{ filterForm.name }}
                        </td>
                        </tr>
                        <tr v-show="filterForm.FirstDate || filterForm.LastDate">
                          <td>{{translate('incomingDocFilter.createDate')}}</td>
                          <td>:</td>
                          <td>
                            {{ filterForm.FirstDate | date }} — {{ filterForm.LastDate | date }}
                          </td>
                        </tr>
                        <tr v-show="filterForm.messageType">
                        <td>{{translate('incomingDocFilter.docType')}}</td>
                        <td>:</td>
                        <td>
                            {{ filterForm.messageType }}
                        </td>
                        </tr>
                        <tr v-show="filterForm.isRead">
                        <td>{{translate('incomingDocFilter.readStatus')}}</td>
                        <td>:</td>
                        <td>
                            {{ filterForm.isRead == '0' ? translate('incomingDocFilter.read') : filterForm.isRead == '1' ? translate('incomingDocFilter.dontRead') : translate('incomingDocFilter.all') }}
                        </td>
                        </tr>
                        <tr v-show="filterForm.isArchived">
                        <td>{{translate('incomingDocFilter.archiveStatus')}}</td>
                        <td>:</td>
                        <td>
                            {{ filterForm.isArchived == '0' ? translate('incomingDocFilter.archived') : filterForm.isArchived == '1' ? translate('incomingDocFilter.dontArchived') : translate('incomingDocFilter.all') }}
                        </td>
                        </tr>
                        <tr v-show="filterForm.UserIds && filterForm.UserIds.length">
                        <td>{{translate('login.user')}}</td>
                        <td>:</td>
                        <td>
                            <span v-for="s in filterForm.UserIds" :key="s" class="document-type" style="margin-right: 8px">
                                {{ users.filter((x) => x.Id == s)[0].FirstName }} {{ users.filter((x) => x.Id == s)[0].LastName }}</span>
                        </td>
                        </tr>
                        <tr v-show="filterForm.DepartmentIds && filterForm.DepartmentIds.length">
                        <td>{{translate('approvalAuthorityEditorUser.department')}}</td>
                        <td>:</td>
                        <td>
                            <span v-for="s in filterForm.DepartmentIds" :key="s" class="document-type" style="margin-right: 8px">
                                {{ departments.filter((x) => x.Id == s)[0].Name }}</span>
                        </td>
                        </tr>
                        <tr v-show="filterForm.FilterIds && filterForm.FilterIds.length">
                        <td>{{translate('incomingDocFilter.filter')}}</td>
                        <td>:</td>
                        <td>
                            <span v-for="s in filterForm.FilterIds" :key="s" class="document-type" style="margin-right: 8px">
                                {{ incomingFilters.filter((x) => x.Id == s)[0].filterName }}</span>
                        </td>
                        </tr>
                        <tr v-show="filterForm.IncomingChannelIds && filterForm.IncomingChannelIds.length">
                        <td>{{translate('incomingDocFilter.incomingDocReceiver')}}</td>
                        <td>:</td>
                        <td>
                            <span v-for="s in filterForm.IncomingChannelIds" :key="s" class="document-type" style="margin-right: 8px">
                                {{ incomingChannels.filter((x) => x.Id == s)[0].name }}</span>
                        </td>
                        </tr>
                        <tr v-show="filterForm.CategoryIds && filterForm.CategoryIds.length">
                        <td>{{translate('draftEyp.category')}}</td>
                        <td>:</td>
                        <td>
                            <span v-for="s in filterForm.CategoryIds" :key="s" class="document-type" style="margin-right: 8px">
                                {{ categories.filter((x) => x.Id == s)[0].Name }}</span>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
        <list
          v-if="!editFilters"
          ref="incomingDoc"
          :record-per-page="10"
          :columns="columns"
          :filter="filterForm"
          :hideDeleteCommand="true"
          url="/incomingDoc/get"
          modelName="IncomingDocument"
          orderBy="CreateDate desc"
        >
        </list>
      </list-container>
      <router-view v-if="$route.params.id" />
    </div>
    
  </template>
  
  <script>
  const list = () => import( "../components/List.vue");
  import listContainer from "../components/ListContainer.vue";
  import incomingDocFilter from "../components/IncomingDocFilter.vue";
  import ExcelExporter from "../components/ExcelExporter.vue";

  import Vue from "vue";
  
  export default {
      components: {
          list,
          listContainer,
          incomingDocFilter,
          ExcelExporter
      },
      data(){
          var self = this;
          return {
              modelName: 'IncomingDocument',
              incomingDoc : [],
              user: null,
              filterForm: {},
              targetSystems: [],
              incomingFilters: [],
              departments: [],
              categories: [],
              users: [],  
              incomingChannels: [],
              foundIncomingChannel: [],
              predicate: "",
              editFilters: false,
              columns : [
                {
                    Key: "Id",
                    Title: this.translate('incomingDocFilter.documentNo'), 
                },
                {
                    Key: "name",
                    Title: this.translate('draftEyp.subject'),
                    SortField: "name",
                },
                {
                    Key: "type",
                    Title: this.translate('incomingDocumentList.docType'),
                },
                {
                    Key: "Sender",
                    Title: this.translate('targetSystem.rem.sender'),
                },
                {
                    Key: "archiveType",
                    Title: this.translate('incomingDocumentList.archiveType'),
                    Content(i) {
                        return Vue.filter('archiveType')(i.archiveType);
                    }
                },
                {
                    Key: "isRead",
                    Title: this.translate('incomingDocFilter.read'),
                    Content(i) {
                        return Vue.filter('checkicon')(i.isRead);
                    }
                },
                {
                    Key: "isArchived",
                    Title: this.translate('incomingDocument.archived'),
                    Content(i) {
                        return Vue.filter('checkicon')(i.isArchived);
                    }
                },
                {
                    Key: "incomingChannelId",
                    Title: this.translate('incomingDocFilter.incomingDocReceiver'),
                    Content(i) {
                        return self.getChannelName(i.incomingChannel);
                    }
                },
                {
                    Key: "Date",
                    Title: this.translate('incomingDocFilter.createDate'),
                    SortField: "CreateDate",
                    Content(i) {
                        return Vue.filter('date')(i.Date);
                    }
                },
                {
                    Key: "SentDate",
                    Title: this.translate('incomingDocumentList.sentDate'),
                    Content(i) {
                        return Vue.filter('date')(i.SentDate);
                    }
                },
        ],
      };
    },
    created() {
      this.getTargetSystems().then((x) => {
        this.targetSystems = x.Result;
      });
  
      this.getDepartments({ Predicate: "IsActive=true" }).then(
        (x) => {
          this.departments = x.Result;
  
          this.getUsers({ predicate: "IsActive= true", DepartmentIds: this.userDepartmentIds, IncludeFreeUsersInDepartmentFilter: true }).then((x) => {
            this.users = x.Result;
          });
        }
      );
      this.getCategories({ Predicate: "IsActive=true" }).then(x => {
        this.categories = x.Result;
      });
      this.getFilters()
            .then(x => {
                this.incomingFilters = x.Result;
            }).catch(x => {
                console.log("Departman listesi yüklenemedi:", x);
            });
      this.getIncomingChannel().then((x) => {
          this.incomingChannels = x.Result
        })
    },
    methods: {
      applyFilter(filter) {
        this.filterForm = filter;
        this.editFilters = false;
        console.log(this.filterForm)
        this.$forceUpdate();
      },
      resetComponent() {
        if (
          confirm(this.translate('warnings.allIncomingDocChangesWillBeLost'))
        ) {
          this.applyFilter({ Status:[], DocumentTypes: [] })
        }
      },
      getChannelName(i){
        var channel = this.incomingChannels.find(x => x.Id === i)
        if(channel){
          return channel.name;
        }
        else{
          return "";
        }

      }
    },
    computed:{
      userDepartmentIds(){
        var userDepartmentIds = this.$root?.$data?.login?.User?.DepartmentIds ?? [];
        var allDepartmentIds = (this.departments ?? []).filter(x => x.IsActive).map(function(item) { return item.Id});
  
        if(this.hasAuth('Admin'))
          return [];
        else
          return userDepartmentIds.filter(x => allDepartmentIds.indexOf(x) >= 0);
      },
      availableDepartments(){
          var result = (this.departments ?? []).filter(x => x.IsActive);
          var userDepartmentIds = this.userDepartmentIds;
  
          if(!this.hasAuth('Admin') && (userDepartmentIds ?? []).length > 0) {
            var isDepartmentAvailable = function(department) {
              return userDepartmentIds.indexOf(department.Id) >= 0;
            }
            result = result.filter(x => isDepartmentAvailable(x));
          }
            
          
          return result;
      }
    }
  };
  </script>
  <style scoped>
  table.ozet > tbody > tr > td:first-child {
    width: 150px;
  }
  
  .document-type::after {
    content: ",";
  }
  
  .document-type:last-child::after {
    content: "";
  }
  </style>